import React, { useState } from "react";
import { IChannel } from "src/services/amity";
import { Spinner } from "@rio-cloud/rio-uikit";
import NonePng from './imgs/profile.png'
import moment from "moment";
import { formaTimeDifference, formatNamesGroup } from "@utils";

interface IMessagesProps {
    loadingChats: boolean;
    handleNewChat: () => void;
    handleOpenScheduling: () => void;
    handleOpenMessages: (channel: IChannel) => void;
    channels: IChannel[];
    handleUpdateChat: () => void;
}

const Messages = ({ loadingChats, handleNewChat, handleOpenMessages, handleUpdateChat, channels }: IMessagesProps) => {
    const [searchTerm, setSearchTerm] = useState<string>('');

    return (
        <>
            <h3 className="display-flex justify-content-between align-items-center gap-6 chat-sidebar__title">
                Mensagens
                <div>
                    <button
                        type="button"
                        className="btn btn-primary btn-link p-0"
                        onClick={handleUpdateChat}
                    >
                        <span className={`rioglyph rioglyph rioglyph-refresh ${loadingChats ? 'spinning' : '' }`}></span>
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-link p-0"
                        onClick={handleNewChat}
                    >
                        <span className={`rioglyph rioglyph-plus`}></span>
                    </button>
                </div>
            </h3>

            <div className="search-field">
                <div className="form-group padding-left-0">
                    <label className="width-100pct">
                        <input
                            className="form-control margin-y-5"
                            type="text"
                            placeholder="Pesquisar"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button className="btn btn-action padding-0">
                            <span className="rioglyph rioglyph-search text-color-primary"></span>
                        </button>
                    </label>
                </div>
            </div>

            <div className="chats-list">
                {
                    loadingChats && <Spinner isDoubleSized />
                }

                {channels
                    .filter((channel) => channel.displayName.toLowerCase().includes(searchTerm.toLowerCase()))
                    .sort((a, b) => b.lastActivity.getTime() - a.lastActivity.getTime())
                    .map((channel) => (
                        <div
                            key={channel.id}
                            onClick={() => handleOpenMessages(channel)}
                            className="display-flex align-items-center card-info"
                        >
                            <div className="display-flex align-items-center gap-10 width-100pct">
                                <div>
                                    {channel?.members?.length > 1 ? (
                                        <span
                                            className="rioglyph rioglyph rioglyph-user-group text-color-primary text-size-h2 bg-highlight-lighter rounded-circle padding-10"
                                        />
                                    ) : (
                                        <React.Fragment>
                                            <img
                                                src={channel.profileImage ?? NonePng}
                                                alt=""
                                                className="width-40 aspect-ratio-1 rounded-circle object-cover"
                                            />
                                            {channel.hasUnreadMessage ? <span className="card-info__alert" /> : null}
                                        </React.Fragment>
                                    )}
                                </div>
                                <div className="display-flex flex-direction-column w-4/6 card-info__name">
                                    <div className="text-color-black text-size-18 text-medium">
                                        {formatNamesGroup(channel.displayName.split('__')[0])}
                                    </div>
                                    <div className="text-color-gray font-size-12 truncate">
                                        {channel.displayName.split('__')[1]}
                                        {/* Consultor(a) */}
                                    </div>
                                </div>
                            </div>
                            {/* <div className="card-info__time w-1/6">{timeDifference(channel.lastActivity)channel.lastActivity}</div> */}
                            <div className="card-info__time width-20pct display-flex justify-content-end">{formaTimeDifference(channel?.lastActivity?.toISOString())}</div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default Messages;